import { useState } from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'

// Small reusable Check icon
const Check = () => (
  <img src="/icons/check.png" alt="Check" className="w-5 h-5" />
)

const Pricing = () => {
  const [isOpen, setIsOpen] = useState(false)

  const singlePlan = {
    name: "CashMate",
    price: "RM 130.00",
    desc: "One plan with everything included. Unlimited usage across your team and stores.",
    features: [
      "Unlimited users & cashiers",
      "Unlimited products, bundles, and variants",
      "Unlimited storage & backups",
      "All reports and exports included",
      "Customer display, KDS, queue display",
      "API access and integrations",
      "Priority chat & email support",
    ],
  }

  return (
    <div className="relative bg-[#0b0812] min-h-screen">

      {/* Navbar (stays on top using absolute) */}
      <nav className="w-full absolute top-0 left-0 right-0 z-50 bg-transparent text-white px-6 md:px-10 py-6 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img src="/images/logo.png" alt="CashMate Logo" className="h-10 md:h-12" />
          <span style={{ fontFamily: 'Century Gothic' }} className="text-2xl tracking-[8px]">
            CASHMATE
          </span>
        </div>

        <div className="hidden md:flex items-center gap-8 text-sm font-medium text-white/80">
          <a href="/" className="hover:text-white transition">Overview</a>
          <a href="/pricing" className="hover:text-white transition">Pricing</a>
          <a href="/release-note" className="hover:text-white transition">Release Note</a>
          <a href="https://cashmate.tawk.help" className="hover:text-white transition">Help</a>
          <a href="https://nctechnologyhub.com.my/contact" className="hover:text-white transition">Contact</a>
          <Link to="/login">
            <motion.button
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              className="px-5 py-2 text-sm font-semibold tracking-wide text-white bg-white/10 backdrop-blur-md rounded-full border border-white/20 hover:scale-105 transition"
            >
              Sign in
            </motion.button>
          </Link>
        </div>

        {/* Mobile Hamburger */}
        <div className="md:hidden">
          <button onClick={() => setIsOpen(!isOpen)} className="focus:outline-none">
            <svg className="h-6 w-6 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
              {isOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {isOpen && (
          <div className="absolute top-20 left-0 right-0 bg-[#0b0812] shadow-lg text-center px-6 py-8 md:hidden z-40 space-y-6">
            <a href="#overview" className="block text-white/80 hover:text-white transition">Overview</a>
            <a href="/pricing" className="block text-white/80 hover:text-white transition">Pricing</a>
            <a href="/release-note" className="block text-white/80 hover:text-white transition">Release Note</a>
            <a href="https://cashmate.tawk.help" className="block text-white/80 hover:text-white transition">Help</a>
            <a href="https://nctechnologyhub.com.my/contact" className="block text-white/80 hover:text-white transition">Contact</a>
            <Link to="/login">
              <button className="mt-4 w-full px-6 py-2 bg-white/10 text-white border border-white/20 rounded-full hover:scale-105 transition">
                Sign in
              </button>
            </Link>
          </div>
        )}
      </nav>

      {/* Pricing Plans */}
      <section id="pricing" className="pt-28 px-6 md:px-16 text-center">
        <h2 className="text-3xl md:text-5xl font-bold mb-6 text-white">One Plan. All Features.</h2>
        <p className="text-white mb-12">RM130/month • 7-day free trial • No hidden limits</p>

        <div className="max-w-3xl mx-auto">
          <div className="rounded-3xl p-10 shadow-2xl bg-[#1a102b] text-white border border-white/10 flex flex-col">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
              <div className="text-left">
                <p className="text-sm uppercase tracking-[4px] text-purple-300 font-semibold">{singlePlan.name}</p>
                <h3 className="text-4xl font-bold mt-2">{singlePlan.price} <span className="text-base font-normal text-white/70">/ month</span></h3>
                <p className="text-sm text-white/70 mt-2">Tax exclusive</p>
              </div>
              <Link to="/signup">
                <button className="px-8 py-3 rounded-full font-semibold text-sm bg-white text-[#2563eb] hover:opacity-90 transition w-full md:w-auto">
                  Start Free Trial
                </button>
              </Link>
            </div>

            <p className="text-left text-white/80 mb-6">{singlePlan.desc}</p>

            <ul className="grid md:grid-cols-2 gap-3 text-left">
              {singlePlan.features.map((feature, id) => (
                <li key={id} className="flex items-center gap-2">
                  <Check />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>

            <p className="text-xs text-center mt-6 text-white/70">7-day free trial. Cancel anytime.</p>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Pricing;
